import BasePolicy from '@/policies/BasePolicy.js';

/**
 * Mirrors `App\Policies\InstitutionSettingPolicy`.
 *
 * The full institution-settings surface is Owner/Admin only. Instruction Admin
 * is `is_admin` in the SPA, so inheriting `BasePolicy.before()` would let them
 * through the router gate, flash the page, then 403 on the API (868kq4533).
 * Skip that bypass and authorize the same roles the backend uses.
 *
 * Certificate settings stay broader (Owner/Admin/Instruction Admin, corporate
 * only) via `viewCertificates` / `updateCertificates` on the PHP policy;
 * those routes do not use this class's `viewAny`.
 */
export default class InstitutionSettingPolicy extends BasePolicy {
    before() {
        return null;
    }

    viewAny(user) {
        return Boolean(user.is_super_admin);
    }

    view(user) {
        return Boolean(user.is_super_admin);
    }

    create(user) {
        return Boolean(user.is_super_admin);
    }

    update(user) {
        return Boolean(user.is_super_admin);
    }

    delete(user) {
        return Boolean(user.is_super_admin);
    }
}
